import { HealthcareProvider, SpeechNeed } from './interfaces';

/** Resolve support areas using the provider model's existing optional-field semantics. */
export function speechNeedsVisibleToProvider(
    allSpeechNeeds: SpeechNeed[],
    healthcareProvider?: HealthcareProvider
): SpeechNeed[] {
    if (!healthcareProvider) return [];

    const configuredIds = Array.isArray(healthcareProvider.speechNeeds) ?
        healthcareProvider.speechNeeds : null;
    if (configuredIds === null) {
        // Missing means unrestricted for every provider; an explicit [] below means none.
        return allSpeechNeeds;
    }

    return configuredIds
        .map((id) => allSpeechNeeds.find((speechNeed) => speechNeed.id === id))
        .filter((speechNeed): speechNeed is SpeechNeed => speechNeed !== undefined);
}
